module.exports = __webpack_public_path__ + "img/SketchPng5607a3d3f6693465189064a56f004b228eb92c9f7e910ba87de85d3f3f047454.00f8efd1.png";